import _ from 'lodash';

import {getPathDetails, unwrapSingularDataType} from '../../../../ducks/formattersettingshelpers';
import {flattenProjection} from '../../../../ducks/projectionHelpers';

function hasAttributes(dataType) {
    dataType = unwrapSingularDataType(dataType);

    return dataType.discriminatorValue === 'EntityDataType' || dataType.discriminatorValue === 'ProfileEntityType';
}

/**
 * This function is used by the EntityTable and CardEditor formatters to determine the projection of the data.
 * @param settings Formatter settings object
 * @param dataType Data type for the formattter
 * @param indexedFormatters All formatters that are available
 * @returns {string[]} The projection strings
 */
export function attributeBasedProjection(settings, dataType, indexedFormatters) {
    const res = _.flatMap(settings.attributes, (attr) => {
        const path = getPathDetails(dataType, attr.attributePath);
        if (!path.validPath) return [];

        const formatter = indexedFormatters[attr.formatterId];
        if (formatter == null) return [];

        const terminalDataType = path.finalAttribute.dataType;
        const attrPath = path.pathName;

        const nestedRes = formatter.projectionFunction(formatter.settings, terminalDataType, indexedFormatters);
        if (nestedRes == null) {
            if (hasAttributes(terminalDataType)) {
                return [attrPath + '.*'];
            } else {
                return [attrPath];
            }
        } else {
            return _.map(nestedRes, (p) => (p == null ? attrPath : `${attrPath}.${p}`));
        }
    });

    return _.uniq(flattenProjection(res));
}
